// extracted by mini-css-extract-plugin
module.exports = {"item":"item__4eWKC","setByClient":"setByClient__cYeRA"};